import React, { Component } from "react";
import { s360ConfigService } from "../Services/S360Config";

class PopUpMessage extends Component {

    constructor(props) {
        super(props);
        this.messageBoxRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-chat-full-screen-container" >
                <div ref={this.setMessageBoxRef} className="s360-chat-transcript-email-form-container">
                    <div className="s360-pop-up-message-close-icon" onClick={this.props.onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24.674 24.668"><defs></defs><path class="a" style={{ fill: s360ConfigService.config.designDetails.headerColor || "black" }} d="M26.546,23.623l8.813-8.813a2.065,2.065,0,0,0-2.92-2.92L23.625,20.7,14.813,11.89a2.065,2.065,0,1,0-2.92,2.92l8.813,8.813-8.813,8.813a2.065,2.065,0,1,0,2.92,2.92l8.813-8.813,8.813,8.813a2.065,2.065,0,1,0,2.92-2.92Z" transform="translate(-11.285 -11.289)" /></svg>
                    </div>
                    <div className="s360-pop-up-message-label" style={this.textLabelStyle()} >{this.props.popUpMessage || ''}</div>
                </div>
            </div>
        )
    }

    textLabelStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

}

export default PopUpMessage;